// The standardized entity-id label ("Entity ID: 42") and its parenthetical
// suffix form ("(Entity ID: 42)") for ids appended to a name. Keep the label
// in one place so it stays consistent wherever an entity id is shown.
export const entityIdLabel = (id: number | string): string =>
  `Entity ID: ${id}`;

export const entityIdSuffix = (id: number | string): string =>
  `(${entityIdLabel(id)})`;

// "<name> (Entity ID: 42)" — the standard way an entity is named anywhere in the
// app. Mirrors ActivityFeedContent.entity_ref_text on the server, including its
// fallbacks, so a decision reads identically in the admin log and the feed.
export const entityRefLabel = (
  name: string | null | undefined,
  id: number | string | null | undefined
): string => {
  const label = name?.trim() || 'Unknown entity';
  return id ? `${label} ${entityIdSuffix(id)}` : label;
};
